import { prop } from 'ramda';

import { compact } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { FILTER, MENU } from '../../../types/filters';
import { toTextFromProp } from '../fields/text';
import { relatedPushs } from '../partials/related-push';
import { processSlices } from '../slices';
import customSliceMapper from '../slices/innovation-by-la-poste';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicInnovationByLaPoste
 */

/**
 * @typedef {DocumentSchema} InnovationByLaPosteSchema
 */

const processCustomSlices = processSlices(customSliceMapper);

/**
 * Transform the given input into objects
 *
 * @param  {PrismicInnovationByLaPoste} data
 * @return {InnovationByLaPosteSchema}
 */
const processInnovationByLaPoste = (data) =>
  compact({
    uid: DocumentType.INNOVATION_BY_LA_POSTE,
    type: DocumentType.INNOVATION_BY_LA_POSTE,
    title: toTextFromProp('title', data),
    chapeau: prop('chapeau', data),
    relatedPushs: relatedPushs(data),
    body: processCustomSlices(prop('slices', data)),
    filters: {
      [FILTER.MENU]: MENU.IDENTITY,
    },
  });

/**
 * Normalizr schema representing a innovation-by-la-poste page
 */
export const InnovationByLaPoste = deprecatedPageEntity(
  DocumentType.INNOVATION_BY_LA_POSTE,
  {
    processStrategy: (entity) => ({
      ...processInnovationByLaPoste(prop('data', entity)),
    }),
  }
);
